module.exports = __webpack_public_path__ + "public/SiteImages/editFooterVector.svg?bb43ee7a";